<template>
  <section id="ies3">
    <FadingBigHeadline />
    <IntroductionIES3 />
    <IES3 />
  </section>
</template>

<script>
import IES3 from "./IES3";
import FadingBigHeadline from "./FadingBigHeadline";
import IntroductionIES3 from "./IntroductionIES3";
export default {
  name: "IESSection",
  components: {
    IES3,
    FadingBigHeadline,
    IntroductionIES3
  }
};
</script>
